import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetPhone: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 16.92v3a1 1 0 01-1.1 1 19.86 19.86 0 01-8.63-3.07A19.5 19.5 0 016.18 11.7 19.86 19.86 0 013.12 3.1 1 1 0 014.05 2h3a1 1 0 011 .86 12.86 12.86 0 00.7 2.81 1 1 0 01-.23 1.06l-1.27 1.27a16 16 0 006.07 6.07l1.27-1.27a1 1 0 011.06-.23 12.86 12.86 0 002.81.7 1 1 0 01.86 1.02z" />
      </svg>
    </div>
  );
};

export default WidgetPhone;
